module.exports = __webpack_public_path__ + "img/Giveaway.2fa5c314.jpg";